const dropdowns = [
  {
    id: 1,
    name: "House Cleaning",
    options: [
      { oid: 1, name: "Select Service" },
      {
        oid: 2,
        name: "Sofa Deep Cleaning",
        subOptions: [
          { sid: 1, name: "Select Sofa Deep Cleaning-Options" },
          { sid: 2, name: "Sofa Cleaning - 2 sofa seats" },
          { sid: 3, name: "Sofa Cleaning - 3 sofa seats" },
          { sid: 4, name: "Sofa Cleaning - 4 sofa seats " },
          { sid: 5, name: "Sofa Cleaning - 5 sofa seats" },
          { sid: 6, name: "Sofa Cleaning - 6 sofa seats" },
          { sid: 7, name: "Sofa Cleaning - 7 sofa seats " },
          { sid: 8, name: "Sofa Cleaning - 8 sofa seats" },
          { sid: 9, name: "Sofa Cleaning - 9 sofa seats " },
          { sid: 10, name: "Sofa Cleaning - 10 sofa seats" },
          { sid: 11, name: "Sofa Cleaning > 10 Sofa Seats" },
        ],
      },
      {
        oid: 3,
        name: "House Cleaning",
        subOptions: [
          { sid: 1, name: "Select House Cleaning-Options" },
          { sid: 2, name: "Deep Home Cleaning - 1 BHK Vacant " },
          { sid: 3, name: "Deep Home Cleaning - 2 BHK Vacant" },
          { sid: 4, name: "Deep Home Cleaning - 3 BHK Vacant" },
          { sid: 5, name: "Deep Home Cleaning - 4 BHK Vacant" },
          { sid: 6, name: "Deep Home Cleaning - 5 BHK Vacant" },
          { sid: 7, name: "Deep Home Cleaning - 1 BHK Occupied" },
          { sid: 8, name: "Deep Home Cleaning - 2 BHK Occupied" },
          { sid: 9, name: "Deep Home Cleaning - 3 BHK Occupied" },
          { sid: 10, name: "Deep Home Cleaning - 4 BHK Occupied" },
          { sid: 11, name: "Deep Home Cleaning - 5 BHK Occupied" },
          { sid: 12, name: "Deep Home Cleaning - 1 Room Kitchen Set " },
          { sid: 13, name: "Deep Home Cleaning - 1 Room (Upto 200 Sq Ft)" },
          { sid: 14, name: "Deep Home Cleaning - 1 Room 1 Bathroom" },
          { sid: 15, name: "Deep Home Cleaning - 1 Room 1 Balcony" },
          { sid: 16, name: "Deep Home Cleaning - 1 Room 1 Bathroom" },
          { sid: 17, name: "Deep Home Cleaning Villa - 2K-3K sqft " },
         
        ],
      },
      { oid: 4, name: "Office Cleaning" },
      {
        oid: 5,
        name: "Kitchen Cleaning",
        subOptions: [
          { sid: 1, name: "Select Kitchen Cleaning-Options" },
          { sid: 2, name: "Kitchen Cleaning - with Chimney" },
          { sid: 3, name: "Kitchen Cleaning - without Chimney" },
        ],
      },
      {
        oid: 6,
        name: "Bathroom Deep Cleaning",
        subOptions: [
          { sid: 1, name: "Select Bathroom Deep Cleaning-Options " },
          { sid: 2, name: "Bathroom cleaning - 1 Bathroom" },
          { sid: 3, name: "Bathroom cleaning - 2 Bathroom " },
          { sid: 4, name: "Bathroom cleaning - 3 Bathroom" },
          { sid: 5, name: "Bathroom cleaning - 4 Bathroom" },
          { sid: 6, name: "Bathroom cleaning - 5 Bathroom " },
          { sid: 7, name: "Bathroom cleaning - 6 Bathroom" },
          { sid: 8, name: "Bathroom cleaning - 6 To 8 Bathrooms" },
          { sid: 9, name: "Bathroom cleaning - 8 To 10 Bathrooms" },
          { sid: 10, name: "Bathroom cleaning -> 10 Bathrooms" },
        ],
      },
      {
        oid: 7,
        name: "Sanitation",
        subOptions: [
          { sid: 1, name: "Select Sanitization-Options" },
          { sid: 2, name: "Home Sanitization - 1 BHK " },
          { sid: 3, name: "Home Sanitization - 2 BHK" },
          { sid: 4, name: "Home Sanitization - 3 BHK" },
          { sid: 5, name: "Home Sanitization - 4 BHK " },
          { sid: 6, name: "Home Sanitization - 5 BHK" },
          { sid: 7, name: "Home Sanitization - 1 Room 1 Bathroom" },
          { sid: 8, name: "Home Sanitization - 1 Room Kitchen Set" },
          { sid: 9, name: "Home Sanitization Villa - 2K-3K sqft " },
          { sid: 10, name: "Home Sanitization Villa - 3K-4K sqft" },
          { sid: 11, name: "Home Sanitization Villa - 4K - 5K sqft" },
        ],
      },
      {
        oid: 8,
        name: "Carpet Cleaning",
        subOptions: [
          { sid: 1, name: "Select Carpet Cleaning-Options" },
          { sid: 2, name: "Carpet Deep Cleaning - 0-25 Sq Ft" },
          { sid: 3, name: "Carpet Deep Cleaning - 25-50 Sq Ft" },
          { sid: 4, name: "Carpet Deep Cleaning - 50-100 Sq Ft" },
          { sid: 5, name: "Carpet Deep Cleaning - 100-150 Sq Ft" },
          { sid: 6, name: "Carpet Deep Cleaning - 150-250 Sq Ft " },
          { sid: 7, name: "Carpet Deep Cleaning - 250-500 Sq Ft" },
          { sid: 8, name: "Carpet Deep Cleaning - 500-1000 Sq Ft" },
          { sid: 9, name: "Carpet Deep Cleaning - 1000-2000 Sq Ft" },
          { sid: 10, name: "Carpet Deep Cleaning - 2000-5000 Sq Ft " },
          { sid: 11, name: "Carpet Deep Cleaning - 5000-10000 Sq Ft" },
        ],
      },
      {
        oid: 9,
        name: "Chair Cleaning",
        subOptions: [
          { sid: 1, name: "Select Chair Cleaning-Options" },
          { sid: 2, name: "Chair Deep Cleaning - 5-10 Chairs" },
          { sid: 3, name: "Chair Deep Cleaning - 10-15 Chair" },
          { sid: 4, name: "Chair Deep Cleaning - 15-20 Chairs " },
          { sid: 5, name: "Chair Deep Cleaning - 20-30 Chairs" },
          { sid: 6, name: "Chair Deep Cleaning - 30-50 Chairs" },
          { sid: 7, name: "Chair Deep Cleaning - 50-75 Chairs" },
          { sid: 8, name: "Chair Deep Cleaning - 75-100 Chairs " },
          { sid: 9, name: "Chair Deep Cleaning->100 Chairs" },
        ],
      },
      { oid: 10, name: "Glass Cleaning" },
      { oid: 11, name: "Carpenters" },
      { oid: 12, name: "Painters" },
      { oid: 13, name: "CLeaning service" },
      { oid: 14, name: "Pest Control",
        subOptions: [
          { sid: 1, name: "Select Pest Control-Options" },     
          { sid: 2, name: "Pest Control-Option 1" },     
          { sid: 3, name: "Pest Control-Option 2" },     
          { sid: 4, name: "Pest Control-Option 3" },     
          { sid: 5, name: "Pest Control-Option 4" },     
    ]},
      { oid: 15, name: "Packers and Movers" },
      { oid: 16, name: "Plumbers" },
      { oid: 17, name: "Electricians" },
      {
        oid: 18,
        name: "AC Repair",
        subOptions: [
           { sid: 1, name: "Select AC Service-Options" },
           { sid: 2, name: "Split AC Service - Check-Up" },
           { sid: 3, name: "Split AC Service - Full Service" },
           { sid: 4, name: "Split AC Service - 1 AC Installation" },
           { sid: 5, name: "Split AC Service - 2 AC Installation" },
           { sid: 6, name: "Split AC Service - 3 AC Installation" },
           { sid: 7, name: "Split AC Service - 4 AC Installation " },
           { sid: 8, name: "Split AC Service - 5 AC Installation" },
           { sid: 9, name: "Split AC Service - 1 AC Uninstallation " },
          { sid: 10, name: "Split AC Service - 2 AC Uninstallation" },
          { sid: 11, name: "Split AC Service - 3 AC Uninstallation" },
          { sid: 12, name: "Split AC Service - 4 AC Uninstallation" },
          { sid: 13, name: "Split AC Service - 5 AC Uninstallation " },
          { sid: 14, name: "Window AC Service - Check-Up" },
          { sid: 15, name: "Window AC Service - Full Service" },
          { sid: 16, name: "Window AC Service - 1 AC Installation" },
          { sid: 17, name: "Window AC Service - 2 AC Installation" },
          { sid: 18, name: "Window AC Service - 3 AC Installation" },
          { sid: 19, name: "Window AC Service - 4 AC Installation" },
          { sid: 20, name: "Window AC Service - 5 AC Installation " },
          { sid: 21, name: "Window AC Service - 1 AC Uninstallation" },
          { sid: 22, name: "Window AC Service - 2 AC Uninstallation" },
          { sid: 23, name: "Window AC Service - 3 AC Uninstallation" },
          { sid: 24, name: "Window AC Service - 4 AC Uninstallation " },
          { sid: 25, name: "Window AC Service - 5 AC Uninstallation" },
        ],
      },
    ],
  },
];

export default dropdowns;
